// IMPORTS ======================================
//** CORE
import core from './scripts/login/core/core';
import configCommon from './scripts/common/config';
import config from './scripts/login/core/config';
import model from './scripts/login/core/model';
import service from './scripts/login/core/service';
import helper from './scripts/login/core/helperLogout';
// ==============================================

(function (Model, Service, Config, Helper, $) {    
       // console.log('logout/logout.html');
        var url = decodeURI(window.location);
        var queryString = url.replace(/^[^\?]+\??/,'');
        var params = tb_parseQuery(queryString);
        var pagina = params['pagina'];

        logout({
            url: pagina
        });


    function tb_parseQuery(query) {
        var Params = {};
        if (!query) { return Params; }// return empty object
        var Pairs = query.split(/[|]/);
        for (var i = 0; i < Pairs.length; i++) {
            var KeyVal = Pairs[i].split('=');
            if (!KeyVal || KeyVal.length != 2) { continue; }
            var key = unescape(KeyVal[0]);
            var val = unescape(KeyVal[1]);
            val = val.replace(/\+/g, ' ');
            Params[key] = val;
        }
        //console.log("tb_parseQuery.Params = " + Params);
        return Params;
    }

    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
    

    function logout(options){  
        try{
            Model.Usuario.xToken = readCookie("token");
            Model.Usuario.xValue = readCookie("xvalue");
            if ((Model.Usuario.xToken != null) && (Model.Usuario.xValue != null) && Model.Usuario.xToken && Model.Usuario.xValue) {
                ajaxPost('/Usuario/Logout', Model.Usuario, function (res, status, xhr) {
                    //Service.smartlockSignOut();
                    Helper.resetAll();
                    returnBackLogout(options);
                }, function () {
                    Helper.resetAll();
                    returnBackLogout(options);
                }, {
                    sentHeader: true
                });
            }
        }
        catch(ex)
        {
            console.warn(ex);
        }
       
    }
    function redirectUrl(url) {
        window.location = url;
    }

    function returnBackLogout (options) {
        var pagina = ((!isEmpty(options) && !isEmpty(options.url)) ? options.url : Model.Window.pagina);
        if (!isEmpty(pagina)) redirectUrl(pagina || Config.defaultRedirectUrl);
    }

     function isEmpty(obj) {
        if (obj == null) return true;
        if (obj.length > 0) return false;
        if (obj.length === 0) return true;
        for (var key in obj) {
            if (hasOwnProperty.call(obj, key)) return false;
        }
        return true;
     }

     function ajaxPost(url, data, done, error, options) {
         var sentHeader = ((!isEmpty(options) && 'sentHeader' in options) ? true : false);
         var showPreloader = ((!isEmpty(options) && 'showPreloader' in options) ? true : false);
         var hidePreloader = ((!isEmpty(options) && 'hidePreloader' in options) ? true : false);
         var api = ((!isEmpty(options) && 'paywallApi' in options) ? Config.apiPaywallUrl : Config.apiLoginUrl);
         var headers = {
             'X-Token': Model.Usuario.xToken || '',
             'X-Value': Model.Usuario.xValue || '',
             'X-Key': Model.Usuario.xKey || ''
         };
         $.ajax({
             url: api + url,
             type: 'POST',
             crossDomain: true,
             data: data || null,
             headers: (sentHeader == true ? headers : null),
             success: function (response, status, xhr) {
                 //success && success(response,status,xhr);
             },
             error: function (response) {
                 error && error(response);
             },
             complete: function (response, status, xhr) {
             }
         }).done(function (res, status, xhr) {
             try {
                 var r = res;
                 if (typeof res == 'string') r = JSON.parse(res);
                 done && done(r, status, xhr);
             } catch (e) {
                 console.log(e);
             }
         }).fail(function (jqXHR, textStatus, errorThrown) {
             error && error(jqXHR);
         });
     }

})(LN.Model, LN.Service, LN.Config, LN.Helper, jQuery);


// WEBPACK FOOTER //
// ./Statics/logout.js